// extracted by mini-css-extract-plugin
module.exports = {"q_title_text":"QTitle_q_title_text__3cVtW","mobile":"QTitle_mobile__1Th3U"};